import type { Activity } from "../types/activity";

// Current date: February 3, 2026
const now = new Date(2026, 1, 3); // Feb 3, 2026

export const ACTIVITIES: Activity[] = [
  // Finance user notifications (scenario sharing, comments, approvals)
  {
    id: "activity-1",
    type: "scenario-shared",
    scenarioId: "scenario-cost-cut",
    scenarioName: "Cost Cutting Plan",
    userId: "linda",
    userName: "Linda Kowalski",
    message: 'Linda Kowalski shared "Cost Cutting Plan" with you',
    timestamp: new Date(now.getTime() - 2 * 60 * 60 * 1000), // 2 hours ago
    isRead: false,
    targetPersonas: [
      "preparer",
      "manager",
      "regional",
      "cfo",
      "ceo",
      "external",
    ], // NOT admin
  },
  {
    id: "activity-2",
    type: "comment-added",
    scenarioId: "scenario-moderate",
    scenarioName: "B: Moderate Growth",
    userId: "marcus",
    userName: "Marcus Patel",
    message: 'Marcus Patel commented on "B: Moderate Growth"',
    timestamp: new Date(now.getTime() - 3 * 60 * 60 * 1000), // 3 hours ago
    isRead: false,
    targetPersonas: [
      "preparer",
      "manager",
      "regional",
      "cfo",
      "ceo",
      "external",
    ], // NOT admin
  },
  {
    id: "activity-3",
    type: "approval-requested",
    scenarioId: "scenario-hire",
    scenarioName: "Hire 5 Engineers",
    userId: "sarah",
    userName: "Sarah Mitchell",
    message: 'Sarah Mitchell requested approval for "Hire 5 Engineers"',
    timestamp: new Date(now.getTime() - 5 * 60 * 60 * 1000), // 5 hours ago
    isRead: false,
    targetPersonas: ["regional", "cfo", "ceo"], // Only approvers, NOT admin
  },
  {
    id: "activity-4",
    type: "scenario-edited",
    scenarioId: "scenario-aggressive",
    scenarioName: "C: Aggressive Growth",
    userId: "catherine",
    userName: "Catherine Hughes",
    message: 'Catherine Hughes viewed "C: Aggressive Growth"',
    timestamp: new Date(now.getTime() - 24 * 60 * 60 * 1000), // 1 day ago
    isRead: true,
    targetPersonas: [
      "preparer",
      "manager",
      "regional",
      "cfo",
      "ceo",
      "external",
    ], // NOT admin
  },
  {
    id: "activity-5",
    type: "approval-granted",
    scenarioId: "scenario-moderate",
    scenarioName: "B: Moderate Growth",
    userId: "linda",
    userName: "Linda Kowalski",
    message: 'Linda Kowalski approved "B: Moderate Growth"',
    timestamp: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    isRead: true,
    targetPersonas: [
      "preparer",
      "manager",
      "regional",
      "cfo",
      "ceo",
      "external",
    ], // NOT admin
  },
  {
    id: "activity-6",
    type: "scenario-parked",
    scenarioId: "scenario-scotland",
    scenarioName: "Expand to Scotland",
    userId: "sarah",
    userName: "Sarah Mitchell",
    message: 'Sarah Mitchell parked "Expand to Scotland"',
    timestamp: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000), // 3 days ago
    isRead: true,
    targetPersonas: [
      "preparer",
      "manager",
      "regional",
      "cfo",
      "ceo",
      "external",
    ], // NOT admin
  },

  // System Administrator notifications
  {
    id: "activity-admin-1",
    type: "system-sync-failed",
    userId: "system",
    userName: "System",
    message:
      "Access Financials connection timeout - last successful sync 3 hours ago",
    timestamp: new Date(now.getTime() - 2 * 60 * 60 * 1000), // 2 hours ago
    isRead: false,
    targetPersonas: ["admin"],
    severity: "error",
    actionLabel: "Retry Sync",
  },
  {
    id: "activity-admin-2",
    type: "system-access-request",
    userId: "emma",
    userName: "Emma Thompson",
    message: "Emma Thompson requested Finance Manager role access",
    timestamp: new Date(now.getTime() - 5 * 60 * 60 * 1000), // 5 hours ago
    isRead: false,
    targetPersonas: ["admin"],
    severity: "warning",
    actionLabel: "Review Request",
  },
  {
    id: "activity-admin-3",
    type: "system-config-change",
    userId: "sarah",
    userName: "Sarah Mitchell",
    message: "Sarah Mitchell updated VAT return schedule to monthly",
    timestamp: new Date(now.getTime() - 24 * 60 * 60 * 1000), // 1 day ago
    isRead: false,
    targetPersonas: ["admin"],
    severity: "info",
    actionLabel: "View Change",
  },
  {
    id: "activity-admin-4",
    type: "system-security-alert",
    userId: "system",
    userName: "System",
    message: "3 failed login attempts for john.smith@buildright.co.uk",
    timestamp: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000), // 2 days ago
    isRead: false,
    targetPersonas: ["admin"],
    severity: "warning",
    actionLabel: "View Details",
  },
];
